import React from 'react';
import t from 'rcm-i18n';
import { orderIsDistribturorSignup } from '../service/orderIsDistribturorSignup';
import ContentAreaPopupDisplay from './ContentAreaPopupDisplay';

interface Props {
    order: any;
}

const DistributorSignupReceiptMessage = ({ order }: Props) => {
    return <>
        {orderIsDistribturorSignup(order) &&
            <ContentAreaPopupDisplay areaName="checkoutDistributorSignupReceiptPopup" />
        }
    </>;
};

export default DistributorSignupReceiptMessage;
